import { useState, useCallback } from 'react';
import { MediaItem } from 'app/pages/request-single-page/components-v4';

export const useFilesState = () => {
  const [committedFiles, setCommittedFiles] = useState<MediaItem[]>([]);
  const [draftFiles, setDraftFiles] = useState<MediaItem[]>([]);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleDraftChange = useCallback((files: MediaItem[]) => {
    setDraftFiles(files);

    if (files.length) {
      setDialogOpen(true);
    }
  }, []);

  const discardDraft = useCallback(() => {
    setDraftFiles([]);
    setDialogOpen(false);
  }, []);

  const commitFiles = useCallback((files: MediaItem[]) => {
    setCommittedFiles((prev) => [...prev, ...files]);
  }, []);

  return {
    committedFiles,
    setCommittedFiles,
    draftFiles,
    setDraftFiles,
    dialogOpen,
    handleDraftChange,
    commitFiles,
    discardDraft,
  };
};
